var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHuluLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 9,
    viewBox: "0 0 28 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.94318 2.70814H4.35155V2.7108C5.7339 2.7108 6.84759 3.32189 6.84759 4.91178V8.70442H4.64624V5.19334C4.64272 4.88374 4.3809 4.63358 4.05686 4.63022H2.77678C2.4531 4.63406 2.19184 4.88408 2.18833 5.19334V8.69465H0V0H2.19948V2.82982C2.19948 2.82982 2.44397 2.70814 2.94318 2.70814ZM19.1349 8.70442H16.9336V0H19.1349V8.70442ZM12.479 6.77981C12.8025 6.77644 13.0639 6.52668 13.0675 6.21757V6.21755C13.0675 6.1096 13.0675 2.71094 13.0544 2.71094H15.2558V6.39521C15.2558 7.75239 14.4238 8.69389 13.0544 8.69389H10.9042C9.41963 8.69389 8.4082 7.89895 8.4082 6.39521V2.71094H10.6095V6.21757C10.6136 6.52683 10.8752 6.77645 11.1989 6.77981H12.479ZM25.4435 2.70703V6.21633C25.44 6.52544 25.1786 6.7752 24.855 6.77857H23.5749C23.2514 6.7752 22.99 6.52544 22.9865 6.21633V2.7097H20.7852V6.39397C20.7852 7.89771 21.7966 8.69265 23.2812 8.69265H25.4314C26.8007 8.69265 27.6327 7.75115 27.6327 6.39397V2.7097L25.4435 2.70703Z",
    fill: "#1CE783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuluLogo);
export default __webpack_public_path__ + "static/media/hulu-logo.e30d59d432d8eb996a30a8639b8da4dd.svg";
export { ForwardRef as ReactComponent };